// components/ModalAds.tsx
import { Modal } from 'antd'
import { getImageUrl } from 'src/helpers/functions'

interface ModalAdsProps {
    visible: boolean
    onOk?: () => void
    onCancel?: () => void
    afterClose?: () => void
    selectedItem: {
        image?: string
        description?: string
    }
}

const ModalAds: React.FC<ModalAdsProps> = ({
    visible,
    onOk,
    onCancel,
    afterClose,
    selectedItem
}) => {
    return (
        <Modal
            visible={visible}
            onOk={onOk}
            onCancel={onCancel}
            afterClose={afterClose}
            closable={true}
            footer={null}
            maskClosable={true}
            zIndex={999}
            centered
            width={'auto'}
            style={{
                background: 'transparent',
                boxShadow: 'none',
                padding: 0,

                borderRadius: '6px',
                overflow: 'hidden',
                maxWidth: '800px', marginTop: '5%'
            }}
            bodyStyle={{
                padding: 0,
                background: 'transparent',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <img
                src={getImageUrl(selectedItem?.image)}
                alt="Ad"
                style={{
                    width: '100%',
                    maxWidth: '800px',
                    maxHeight: 400,
                    display: 'block',
                    objectFit: 'contain',
                }}
            />
        </Modal>
    )
}

export default ModalAds
